import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'wonderbly-components/lib/Icon';
import RichText from '../Prismic/RichText';

import './HelpContentModules.scss';

const HelpContentModules = (props) => {
  if (!Array.isArray(props.helpContentModules) || props.helpContentModules.length === 0) {
    return null;
  }
  return (
    <section className="help-content-modules">
      {props.helpContentModules.map((module, idx) => {
        return (
          <div key={`module-${idx}`} className="help-content-module">
            <Icon icon={module.icon} />
            <div className="help-content-module-content">
              <p className="help-content-module-title">{module.title}</p>
              <RichText fields={module.description} className="module-description text-milli" />
            </div>
          </div>
        );
      })}
    </section>
  );
};

HelpContentModules.propTypes = {
  helpContentModules: PropTypes.array,
  icon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.array,
};

export default HelpContentModules;



// WEBPACK FOOTER //
// ./src/client/js/view/components/HelpContentModules/HelpContentModules.js